/**
 * Pure derivation: feature-key list → derived lane bundle keys. Lives in its
 * own module (no axios dependency) so it can be unit-tested cleanly under
 * Jest without hauling in the API instance chain.
 *
 * Mirrors the C# `LaneKeyDeriver.Derive` in
 * flex2-api/Services/Entitlements/LaneKeyDeriver.cs.
 */

import { LANE_CHILDREN, LANE_KEYS } from "auth/entitlementKeys";

/** Reverse map: feature-key → lane-key. Built once at module load. */
const FEATURE_TO_LANE = (() => {
  const map = {};
  Object.entries(LANE_CHILDREN).forEach(([laneId, children]) => {
    if (laneId === "platform_foundation") return; // implicit floor — no lane key
    const laneKey = Object.values(LANE_KEYS).find((k) => k === `lane.${laneId}`);
    if (!laneKey) return;
    children.forEach((featureKey) => {
      map[featureKey] = laneKey;
    });
  });
  return map;
})();

/** Returns the set of lane bundle keys implied by a list of feature keys. */
export const deriveLaneKeys = (featureKeys) => {
  if (!Array.isArray(featureKeys)) return [];
  const out = new Set();
  featureKeys.forEach((k) => {
    const lane = FEATURE_TO_LANE[k];
    if (lane) out.add(lane);
  });
  return Array.from(out).sort();
};

/** Diagnostic helper — read-only map. */
export const featureToLaneMap = () => ({ ...FEATURE_TO_LANE });
